module.exports = __webpack_public_path__ + "img/Article4C.3410cf44.jpg";